import React from 'react';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="container py-5">
        <h1 className="display-4 text-center mb-5">About Joey Pandina</h1>
        
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow">
              <div className="card-body">
                <h2 className="card-title mb-4">My Story</h2>
                <p className="card-text">
                  I'm Joey Pandina, a recent Computer Science graduate with a passion for mathematics and education. 
                  Throughout my academic journey, I discovered that I have a natural talent for explaining complex 
                  mathematical concepts in simple, understandable ways.
                </p>
                <p className="card-text">
                  My interest in math tutoring started during my college years, where I often found myself helping 
                  classmates understand difficult concepts. I found immense satisfaction in seeing that "aha!" 
                  moment when a challenging concept finally clicks for someone.
                </p>
                <p className="card-text">
                  After graduating with my Bachelor's degree in Computer Science, I decided to combine my technical 
                  expertise with my passion for teaching to help middle and high school students excel in mathematics.
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow">
              <div className="card-body">
                <h2 className="card-title mb-4">My Teaching Philosophy</h2>
                <p className="card-text">
                  I believe that every student can succeed in mathematics with the right guidance and approach. 
                  My teaching philosophy centers around these key principles:
                </p>
                <ul className="list-group list-group-flush mb-3">
                  <li className="list-group-item">
                    <strong>Understanding Over Memorization:</strong> I emphasize conceptual understanding rather 
                    than rote memorization, ensuring students grasp the "why" behind mathematical processes.
                  </li>
                  <li className="list-group-item">
                    <strong>Patient Guidance:</strong> I understand that everyone learns at their own pace, and I provide 
                    patient, supportive guidance tailored to each student's needs.
                  </li>
                  <li className="list-group-item">
                    <strong>Building Confidence:</strong> Many students struggle with math anxiety. I focus on building 
                    confidence by celebrating progress and creating a positive learning environment.
                  </li>
                  <li className="list-group-item">
                    <strong>Real-World Context:</strong> I connect mathematical concepts to real-world applications, 
                    helping students see the relevance and importance of what they're learning.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow">
              <div className="card-body">
                <h2 className="card-title mb-4">Education & Qualifications</h2>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    <strong>Bachelor of Science in Computer Science</strong>
                    <br />
                    <em>Graduated: 2025</em>
                  </li>
                  <li className="list-group-item">
                    <strong>Advanced Mathematics Coursework</strong>
                    <br />
                    <span>Including Calculus, Linear Algebra, Discrete Mathematics, and Statistics</span>
                  </li>
                  <li className="list-group-item">
                    <strong>Programming & Problem-Solving Skills</strong>
                    <br />
                    <span>My background in computer science enhances my ability to approach math problems from multiple angles</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
